module.exports = __webpack_public_path__ + "media/images/rie-thinking-d3e75be4.png";